module.exports = __webpack_public_path__ + "static/media/metamask.1ee84d24.png";